export default __webpack_public_path__ + "static/media/pangolin.a3fae9c7.png";